export default __webpack_public_path__ + "static/media/user-400-1.75fb4ee2.jpg";